export const SolutionTabType = Object.freeze({
  APPLICATION_NOTE: "APPLICATION_NOTE",
  TECHNICAL_GUIDE: "TECHNICAL_GUIDE",
  SAMPLE: "SAMPLE"
});

